import React from "react"
import { Component } from "react"
import { Link } from "react-router-dom"
// import FixProfileNavbar from "../../Components/Navbar/FixProfileNavbar";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
import AdminWrapper from "./AdminWrapper"
import { connect } from "react-redux"
import TeacherInfoHeader from "./TeacherInfoHeader"
import { API } from "../../API"

export class TeacherBanking extends Component {
  constructor(props) {
    super(props)
    //console.log("props: "+ JSON.stringify(props))
    // let user = JSON.parse(window.localStorage.getItem("teacher"));
    let user = JSON.parse(window.sessionStorage.getItem("admin-check-teacher"))
    // console.log("user: ", user)
    if (user === null) {
      window.location = "/login"
    }

    this.state = {
      user: user,
      first_name: user.first_name,
      last_name: user.last_name,
      preferred_name: user.preferred_name,
      prefered_work_location: user.prefered_work_location,
      account_name: "",
      account_number: "",
      bsb: "",
      bank_name: "",
      tfn: "",
      tax_threshold: "",
      has_loan: "",
      has_debt: "",
      fund_type: "",
      fund_abn: "",
      fund_name: "",
      usi: "",
      member_number: "",
      fund_bsb: "",
      fund_bank_acc_no: "",
      fund_phone: ""
    }
  }

  setBankingDetails = (data) => {
    if (data.fund_type === "regulated") {
      this.setState({
        fund_type: "Regulated Super Fund",
        fund_abn: data.fund_abn,
        fund_name: data.fund_name,
        usi: data.usi,
        member_number: data.member_number
      })
    }
    else if (data.fund_type === "self-managed") {
      this.setState({
        fund_type: "Self-Managed Super Fund",
        fund_abn: data.fund_abn2,
        fund_name: data.fund_name2,
        // usi: data.usi,
        member_number: data.member_number2,
        fund_bsb: data.fund_bsb,
        fund_bank_acc_no: data.fund_bank_acc_no
      })
    }
    else if (data.fund_type === "default") {
      this.setState({
        fund_type: "Default RT Super Fund",
        fund_abn: "65 714 394 898",
        fund_name: "Australian Super",
        usi: "STA0100AU",
        fund_phone: "1300 300 273"
      })
    }
    else if (data.fund_type === "stapled") {
      this.setState({
        fund_type: "Stapled Super Fund",
      })
    }
  }

  setTaxDeclaration = (data) => {
    // console.log(data)
    this.setState({
      tax_threshold: data.tax_threshold,
      has_loan: data.has_loan,
      has_debt: data.has_debt,
    })
  }

  componentDidMount() {
    API.getUserSensitiveData(this.state.user._id)
      .then(res => {
        this.setTaxDeclaration(res.data.user)
        this.setBankingDetails(res.data.user)
      })
      .catch(err => {
        console.log(err)
      })

    API.getFullBankData(this.state.user._id)
      .then(res => {
        if (res.data.bank_details) {
          console.log(res.data.bank_details)
          this.setState(res.data.bank_details)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  render() {
    return (
      <AdminWrapper>
        <SwitchMenuBar isViewAsTeacher />

        <div className="auth-right d-lg-flex bg-photoregister ">
          <div className="bg-gradient"></div>
          <div className="profile-container">
            <div className="profile-content-card-area">
              <div className="tab-content clearfix">
                <TeacherInfoHeader user={this.state.user} />
                <div className="mt-5">

                  {/* navigationbar on top */}
                  <div className="userNavigation d-flex justify-content-between">
                    <Link
                      to={{
                        pathname: "/AllTeachers",
                      }}
                      className="user-links text-center d-flex  btn-primary primary-button-no-margin-hover text-white"
                    >
                      <p>BACK</p>
                    </Link>
                    <div className="behind-user-links">
                      <Link
                        to={
                          {
                            pathname: "/TeacherNotes"
                          }
                        }
                        className="user-links  d-flex user-links-background-transparent "
                      >
                        <p>Team Notes</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={
                          {
                            pathname: "/TeacherpersonalDetails"
                          }
                        }
                        className="user-links d-flex user-links-background-transparent "
                      >
                        <p>P.Info/I.D.</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          //pathname: "/TeacherBanking",
                        }}
                        className="user-links  user-links-active text-center d-flex  "
                      >
                        <p>Banking</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/validatedocuments",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>Uploads</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherCalendar",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>Calendar</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherJoblistAdmin",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>JobList</p>
                      </Link>
                    </div>
                  </div>

                  {/* cpntent of the form */}
                  <div className="availability-table-container">
                    <div className="availability-table">
                      {/* container of the form */}
                      <div className="availability-table-body  mb-5 mt-5">
                        <div className="availability-table-body-content h-100">
                          <div className="container mt-3">
                            <div className="">
                              {/* TESTING BEFORE IMPLEMENTATION */}
                              {/* <script src="https://cdn.jsdelivr.net/npm/places.js@1.16.4"></script> */}

                              <div className="">
                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">
                                    Banking Details
                                  </h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>
                                <div className="auth-text-top mb-3 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Account Name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.account_name}</p>
                                      {/* {this.state.contact_number} */}
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Bank Name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.bank_name}</p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        BSB:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.bsb}</p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Account Number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.account_number}</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"/>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">Tax Declaration</h5>{" "}
                                  <div className="light-blue-border ml-3"/>
                                </div>
                                <div className="auth-text-top mb-3 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Claim tax-free threshold:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.tax_threshold === undefined
                                          ? null
                                          : this.state.tax_threshold ? "Yes" : "No"}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Have HELP, SSL or TSL Debt:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.has_loan === undefined ? null : this.state.has_loan ? "Yes" : "No"}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Have financial supplement debt:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">
                                        {this.state.has_debt === undefined ? null : this.state.has_debt ? "Yes" : "No"}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {/*
                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">ABN</h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>

                                <div className="auth-text-top mb-3 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        ABN Number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6  my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0 line-height-24">
                                        Address:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17  text-capitalize line-height-24"></p>
                                    </div>
                                  </div>

                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Registered per GST:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>

                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Tax Declaration:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>
                                </div>
                                */}

                                <div className="d-flex mb-4">
                                  <div className="light-blue-border mr-3"></div>{" "}
                                  <h5 className="mb-0 mt-3 w-fillava">
                                    Super Annuation
                                  </h5>{" "}
                                  <div className="light-blue-border ml-3"></div>
                                </div>
                                <div className="auth-text-top mb-3 row">
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Fund Type:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.fund_type}</p>
                                    </div>
                                  </div>

                                  {/* <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Employee Identification Number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div> */}

                                  <div className="form-group col-12 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Tax file number (TFN):
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.tfn}</p>
                                    </div>
                                  </div>

                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Fund ABN:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.fund_abn}</p>
                                    </div>
                                  </div>

                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Fund Name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.fund_name}</p>
                                    </div>
                                  </div>

                                  <div className="form-group col-12 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Fund phone:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.fund_phone}</p>
                                    </div>
                                  </div>

                                  <div className="form-group col-lg-12 col-xl-4 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Fund Address:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>

                                  <div className="form-group col-12 col-lg-4 col-xl-3 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Suburb:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>
                                  <div className="form-group col-12 col-lg-4 col-xl-2 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Postal Code:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>
                                  <div className="form-group col-12 col-lg-4 col-xl-2 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        State:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>
                                  {/* if fund type = APRA */}
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        USI:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.usi}</p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Account name:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Member number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.member_number}</p>
                                    </div>
                                  </div>
                                  {/*  end if fund type == APRA */}
                                  {/* else => if fund type == SMSF */}
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        ESA:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24"></p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        BSB:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.fund_bsb}</p>
                                    </div>
                                  </div>
                                  <div className="form-group col-md-12 col-lg-6 my-1 d-flex line-height-24">
                                    <label className=" line-height-24">
                                      <p className="text-left mb-0  line-height-24">
                                        Account Number:
                                      </p>
                                    </label>
                                    <div className="input-icon ml-2 text-left line-height-24">
                                      <p className="font-17 text-capitalize  line-height-24">{this.state.fund_bank_acc_no}</p>
                                    </div>
                                  </div>
                                  {/*  end if fund type == SMSF */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* navigationbar on bottom */}
                  <div className="adminBottomNavigation ">
                    <Link
                      to={{
                        pathname: "/AllTeachers",
                      }}
                      className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                    >
                      <p>BACK - All Teachers</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminWrapper>
    )
  }
}

function mapStateToProps(state) {
  return {
    teacher: state.admin.teacher,
  }
}

export default connect(mapStateToProps)(TeacherBanking)
